import React from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import desktopActionBarStyles from '../DesktopActionBar.scss';
const FluidMargin = ({ index })=>/*#__PURE__*/ React.createElement(Flex, {
        className: classnames(desktopActionBarStyles['fluid-margin'], desktopActionBarStyles[`fluid-margin-${index}`])
    });
export default FluidMargin;
